<svg [attr.height]="size" [attr.width]="size" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path [attr.stroke]="color"
          d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22Z"
          stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
          stroke-width="1.5"/>
    <path [attr.stroke]="color" d="M18.9004 5L4.90039 19" stroke-linecap="round" stroke-linejoin="round"
          stroke-miterlimit="10" stroke-width="1.5"/>
</svg>